import React, {Fragment} from "react";
import TextInput from "../../../form/TextInput";
import Select from "../../../form/Select";
import CheckBox from "../../../form/CheckBox";
import Conditions from "./Conditions";
import {isFalse, isTrue} from "../../../../utils/other";

class GroupDiscount extends React.Component {

    groupBy = (xs, key) => {
        return xs.reduce((rv, x) => {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        }, {});
    };

    render () {
        let conditions = null;
        if (isFalse(this.props.values.sametarget)) {
            //const propsFilter = this.groupBy(this.props.values.conditions || [], "property");
            conditions = <Conditions
                {...this.props}
                type={"DiscountCondition"}
                name="conditions"
                conditions={this.props.values.conditions}
                saveChanges={this.props.setFieldValue}
            />;
        }
        return (<Fragment>
            <div className="form-group">
                <CheckBox
                    {...this.props.getFieldProps("sametarget")}
                    name="sametarget"
                    value={this.props.values.sametarget}
                    label={"Feltétel szűrés megegyezik a cél szűréssel"}
                    saveChanges={this.props.setFieldValue}
                />
            </div>
            <div className="form-group">
                <CheckBox
                    {...this.props.getFieldProps("target_excludes_condition")}
                    name="target_excludes_condition"
                    value={this.props.values.target_excludes_condition}
                    label={"A feltételhez használt termékre ne vonatkozzon a kedvezmény"}
                    saveChanges={this.props.setFieldValue}
                />
            </div>
            <div className="form-group">
                <label className="control-label">Számítás</label>
                <div className="row">
                    {this.props.values.calculation_strategy !== "one_of_each" && <div className="col">
                        <TextInput
                            type="number"
                            name="condition_qty"
                            label={false}
                            value={this.props.values.condition_qty}
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("condition_qty")}
                        />
                    </div>}
                    <div className="col">
                        <Select
                            {...this.props.getFieldProps("calculation_strategy")}
                            label={false}
                            optionname="DiscountConditionType"
                            storeType="local"
                            objectValue={false}
                            name="calculation_strategy"
                            value={this.props.values.calculation_strategy}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                    <div className="col">
                        <TextInput
                            type="number"
                            name="target_qty"
                            label={false}
                            value={this.props.values.target_qty}
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("target_qty")}
                        />
                    </div>
                </div>
            </div>
            {conditions}
        </Fragment>);
    }
}

export default GroupDiscount;